import React from 'react';
import { styled } from '@compiled/react';
import noop from 'lodash/noop';
import Spinner from '@atlaskit/spinner';
import { defineMessages, useIntl } from '@atlassian/jira-intl';
import Panel from '@atlassian/jira-software-backlog-panel/src/common/ui/panel/main.tsx';

const messages = defineMessages({
	title: {
		id: 'software-version-backlog-panel-relay.common.loading-skeleton.title',
		defaultMessage: 'Versions',
		description: 'Backlog version panel title.',
	},
});

export const LoadingSkeleton = () => {
	const { formatMessage } = useIntl();

	return (
		<Panel title={formatMessage(messages.title)} onClose={noop}>
			<LoadingWrapper>
				<Spinner size="medium" />
			</LoadingWrapper>
		</Panel>
	);
};

// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const LoadingWrapper = styled.div({
	display: 'flex',
	justifyContent: 'center',
	// eslint-disable-next-line @atlaskit/design-system/use-tokens-space
	paddingTop: '40%',
});
